import { createAsyncThunk } from '@reduxjs/toolkit'
import { ICommunicationHistory } from '@dataTypes/communicationHistory.type'
import { getCommunicationHistory } from '@services/api/communicationHistory.api'

export const fetchCommunicationHistory = createAsyncThunk<
  ICommunicationHistory[],
  string,
  {
    rejectValue: string
  }
>(
  'api/patient-profile/communication-history/fetch',
  async (patientId, { rejectWithValue }) => {
    try {
      const response = await getCommunicationHistory(patientId)

      if (response.statusCode !== 200) {
        return rejectWithValue(
          response.message || 'Failed to fetch communication history',
        )
      }

      return response.data.logs
    } catch (error: any) {
      return rejectWithValue(error.message || 'An error occurred')
    }
  },
)
